import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIds } from "../hook/AdminContext";
import ProfileSwitchLoader from "../components/loader/ProfileSwitchLoader";

const ValidateToken = () => {
  const {
    userInfo,
    handleSwitchProfile,
    profileSwitchLoader,
    STOP_SOCKET_FORCEFULLY,
  } = useIds();
  const navigate = useNavigate();

  useEffect(() => {
    console.info("stuck 1");
    if (!userInfo?._id) {
      // If no user info, redirect
      localStorage.clear();
      STOP_SOCKET_FORCEFULLY();
      navigate("/login", { replace: true });
      return;
    }

    console.info("stuck 2");

    const hasMultipleProfiles =
      Array.isArray(userInfo.profiles) && userInfo?.profiles.length > 0;
    const isCompanyProfile = Boolean(userInfo?.isCompanyProfile);

    if (
      hasMultipleProfiles &&
      userInfo?.role !== "internal_user" &&
      isCompanyProfile
    ) {
      console.info("stuck 4");
      handleSwitchProfile(userInfo._id);
      return;
    }

    console.info("stuck 3");
    // Clear and redirect
    localStorage.clear();
    STOP_SOCKET_FORCEFULLY();
    // navigate("/login", { replace: true });
    window.location.href = "/login";
  }, []);

  return (
    <>
      {profileSwitchLoader && (
        <ProfileSwitchLoader
          open={profileSwitchLoader}
          text="Switching Profile.."
        />
      )}
    </>
  );
};

export default ValidateToken;
